export default {"src":"/_next/static/media/cookie.e4fb9758.svg","height":40,"width":51,"blurWidth":0,"blurHeight":0};